(() => {
  const PRODUCT_SELECTOR = 'li.product-grid__item[data-product-id]';
  const EXPANDED = 'data-mohseven-variants-expanded';

  const reconcileServerVariants = (li) => {
    const parent = li?.parentElement;
    const productId = li?.dataset?.productId;
    if (!parent || !productId) return false;
    const siblings = Array.from(parent.children).filter(card =>
      card.matches?.(PRODUCT_SELECTOR) && card.dataset.productId === productId
    );
    const serverVariants = siblings.filter(card =>
      card.classList.contains('mohseven-variant-card') && card.dataset.variantId
    );
    if (!serverVariants.length) return false;
    const seen = new Set();
    serverVariants.forEach(card => {
      const variantId = card.dataset.variantId;
      if (seen.has(variantId)) { card.remove(); return; }
      seen.add(variantId);
      card.dataset.mohsevenVariantCard = 'true';
      card.setAttribute(EXPANDED, 'done');
    });
    siblings.forEach(card => {
      if (!card.classList.contains('mohseven-variant-card')) card.remove();
    });
    return true;
  };

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(value); }
    catch { return value.toFixed(2) + ' TL'; }
  };

  const esc = (value) => String(value ?? '')
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

  const variantImage = (variant, product) => {
    const image = variant?.featured_image;
    if (typeof image === 'string') return image;
    if (image?.src) return image.src;
    const featured = product?.featured_image;
    if (typeof featured === 'string') return featured;
    if (featured?.src) return featured.src;
    return '';
  };

  const productPath = (li) => {
    const link = li.querySelector('a.product-card__link[href*="/products/"]') || li.querySelector('a[href*="/products/"]');
    if (!link) return null;
    try {
      const url = new URL(link.href, location.origin);
      const match = url.pathname.match(/^(.*\/products\/[^\/]+)/);
      return match ? match[1] : null;
    } catch { return null; }
  };

  const buildCard = (parent, product, variant, index) => {
    const li = document.createElement('li');
    li.className = 'product-grid__item mohseven-variant-card';
    li.dataset.productId = String(product.id || parent.dataset.productId || '');
    li.dataset.variantId = String(variant.id);
    li.dataset.page = parent.dataset.page || '1';
    li.dataset.mohsevenVariantCard = 'true';
    const color = variant.option1 || variant.title || '';
    const title = (product.title + ' ' + color).trim();
    const url = new URL(product.url || productPath(parent), location.origin);
    url.searchParams.set('variant', variant.id);
    const image = variantImage(variant, product);
    li.innerHTML = '<a class="mohseven-variant-card__link" href="' + esc(url.pathname + url.search) + '" aria-label="' + esc(title) + '">' +
      '<div class="mohseven-variant-card__media">' + (image ? '<img loading="lazy" src="' + esc(image) + '" alt="' + esc(title) + '">' : '') + '</div>' +
      '<div class="mohseven-variant-card__info">' +
      '<div class="mohseven-variant-card__title">' + esc(title) + '</div>' +
      '<div class="mohseven-variant-card__price">' + esc(money(variant.price)) + '</div>' +
      (!variant.available ? '<div class="mohseven-variant-card__soldout">Tükendi</div>' : '') +
      '</div></a>';
    return li;
  };

  const expandOne = async (li) => {
    if (!li || !li.isConnected) return;
    if (reconcileServerVariants(li)) return;
    if (li.hasAttribute(EXPANDED) || li.dataset.mohsevenVariantCard === 'true') return;
    li.setAttribute(EXPANDED, 'loading');
    const path = productPath(li);
    if (!path) { li.setAttribute(EXPANDED, 'skipped'); return; }
    try {
      const res = await fetch(path + '.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('product-json-' + res.status);
      const product = await res.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const managed = variants.some(v => /^MOH-/i.test(String(v.sku || '')));
      if (!managed || variants.length <= 1) { li.setAttribute(EXPANDED, 'done'); return; }
      const frag = document.createDocumentFragment();
      variants.forEach((variant, index) => frag.appendChild(buildCard(li, product, variant, index)));
      li.after(frag);
      li.remove();
    } catch (err) {
      li.setAttribute(EXPANDED, 'error');
      console.warn('[Mohseven Variant Cards]', path, err);
    }
  };

  const scan = (root = document) => root.querySelectorAll(PRODUCT_SELECTOR).forEach(expandOne);
  const start = () => {
    scan();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.(PRODUCT_SELECTOR)) expandOne(node);
          scan(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();